import React, { useState } from 'react';
import PanelReturnAlert from './PanelReturnAlert';
import PlayerStatsTextBox from './PlayerStatsTextBox';
import './index.css'; // Import the CSS file that will import all others
import type { GameStateDto } from '../../types/gameState';
import { useGameState } from '../../state/useGameState';

interface StatsReturnPanelProps {
  gameState: GameStateDto | null;
  onClose: () => void;
}

const StatsReturnPanel: React.FC<StatsReturnPanelProps> = ({ gameState, onClose }) => {
  const { absenceData, playerName, handlePlayerNameSubmit } = useGameState();
  const [isEditing, setIsEditing] = useState(false);
  const [nameValue, setNameValue] = useState(playerName || 'Player');
  
  if (!gameState || !gameState.playerStats) {
    return null;
  }
  
  const commandPoints = {
    available: gameState.commandPointsAvailable,
    used: gameState.commandPointsUsed,
    remaining: gameState.remainingCommandPoints
  };
  
  // Save the edited name
  const handleSaveName = () => {
    const trimmedName = nameValue.trim();
    if (trimmedName) {
      handlePlayerNameSubmit(trimmedName);
    }
    setIsEditing(false);
  };
  
  // Handle Enter key press in the input field
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveName();
    }
  };
  
  // Show absence stats if available and recent
  const showAbsence = absenceData && absenceData.absenceTime > 0 && (absenceData.oreMined > 0 || absenceData.tripsCompleted > 0);
  
  return (
    <div className="return-panel-overlay">
      <div className="return-panel-content">
        <div className="return-panel-item">
          <PanelReturnAlert title="FLEET COMMANDER STATS" />
        </div>
        <div className="return-panel-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>          <span style={{ fontWeight: 600, color: 'var(--color-accent-blue, #4cafef)', fontSize: '1.08em', display: 'flex', alignItems: 'center', gap: 8 }}>
            Commander: 
            {isEditing ? (
              <input 
                type="text"
                value={nameValue}
                onChange={(e) => setNameValue(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
                className="text-input"
                style={{ 
                  background: 'rgba(0, 20, 40, 0.5)',
                  border: '1px solid var(--color-accent-blue, #4cafef)',
                  borderRadius: '4px',
                  color: 'var(--color-text-primary, white)',
                  padding: '4px 10px',
                  fontSize: '1em',
                  margin: 0,
                  width: 'auto',
                  minWidth: '120px'
                }}
                maxLength={32}
              />
            ) : (
              <span style={{ color: 'var(--color-text-primary, #fff)' }}>{playerName || 'Player'}</span>
            )}
          </span>          {isEditing ? (
            <button
              className="return-button-action"
              onClick={handleSaveName}
              title="Save name"
              style={{
                backgroundColor: 'rgba(20, 40, 80, 0.7)',
                border: '1px solid rgba(70, 130, 180, 0.6)',
                color: '#e6e6e6',
                padding: '4px 12px',
                borderRadius: '4px',
                fontSize: '0.9em',
                fontFamily: 'var(--font-family, "Inter", sans-serif)',
                cursor: 'pointer',
                fontWeight: 'normal',
                letterSpacing: '0.5px'
              }}
            >
              Save
            </button>
          ) : (
            <button
              className="return-button-secondary"
              onClick={() => setIsEditing(true)}
              title="Change player name"
              style={{
                backgroundColor: 'rgba(20, 40, 80, 0.6)',
                border: '1px solid rgba(70, 130, 180, 0.5)',
                color: 'var(--color-text-primary, white)',
                padding: '4px 12px',
                borderRadius: '4px',
                fontSize: '0.95em',
                cursor: 'pointer'
              }}
            >
              Edit Name
            </button>
          )}
        </div>
        {showAbsence && (
          <div className="return-panel-item" style={{ marginBottom: 0 }}>
            <div style={{ color: '#ffb300', fontWeight: 600, marginBottom: 8 }}>Recent Absence</div>
            <div style={{ color: '#fff', fontSize: '1.05em', marginBottom: 4 }}>
              Ore Mined While Away: <span style={{ color: '#4caf50' }}>{absenceData.oreMined.toLocaleString()}</span>
            </div>
            <div style={{ color: '#fff', fontSize: '1.05em' }}>
              Trips to Mothership: <span style={{ color: '#2196f3' }}>{absenceData.tripsCompleted.toLocaleString()}</span>
            </div>
          </div>
        )}
        <div className="return-panel-item">
          <PlayerStatsTextBox stats={gameState.playerStats} commandPoints={commandPoints} />
        </div>
        <div className="return-panel-item">
          <button className="return-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default StatsReturnPanel;
